const Theme = {
    colors: {
        header: '#ebfbff',
        body: '#fff',
        footer: '#003333'
    },
    mobile: '768px',
}

export default Theme